<div class="modal-header">
  <h4 class="modal-title">{{'AuthenticateYourSelf' | translate}}</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <ng-template [ngIf]="loading"><div class="loadingScreen"></div></ng-template>
  <alert></alert>
  <form  name="myForm" #myForm="ngForm" class="form-horizontal">

  <div class="container">
      <div class="row">
        <div class="col">
          <label >{{'Authentication' | translate}}</label>
          <input type="text" [focus]="true" name="otp" class="form-control" [(ngModel)]="otp" (keypress)="onValidateKeyPressed($event)">
        </div>
      </div>
  </div>

  </form>

</div>



<div class="modal-footer">
  <button type="button" class="btn btn-primary" [disabled]="!myForm.form.valid"  (click)="onValidate()">{{'Validate' | translate}}</button>
  <button type="button" class="btn btn-link" (click)="onCancel()">{{'Cancel' | translate}}</button>
</div>
